import React from "react";
import { Link } from "react-router-dom";

import { CategoryIcon } from "./icons";
import Pill from "./Pill";

/**
 * The category strip on /help: compact cards, not tall catalogue tiles.
 *
 * Columns come from the viewport (6 / 4 / 2), never from the number of
 * categories -- the content team sets that, and the grid has to stay tidy
 * anywhere from 6 to 14 cards without anyone touching this file.
 */
const CategoryGrid = ({ categories }) => (
  <ul className="hc-cats">
    {categories.map(category => (
      <li key={category.slug}>
        <Link to={`/${category.slug}`} className="hc-cat">
          <span className="hc-cat__icon">
            <CategoryIcon name={category.icon} />
          </span>
          <span className="hc-cat__name">{category.title}</span>
          <span className="hc-cat__count">
            {category.badge === "segera" ? "Segera hadir" : `${category.articles.length} artikel`}
          </span>
          {category.badge ? <Pill kind={category.badge} /> : null}
        </Link>
      </li>
    ))}
  </ul>
);

export default CategoryGrid;
